module.exports = __webpack_public_path__ + "static/media/loader.9d243b17.gif";